module.exports = __webpack_public_path__ + "static/media/press-ny.3f8a4216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/press-ny.png
// module id = 223
// module chunks = 0